var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"section1"}},[_c('div',{staticClass:"fondoFwhite",style:('background-image: url(' + _vm.payImg + ');')})])}
var staticRenderFns = []

export { render, staticRenderFns }